import { UPDATE_PASSWORD_FROM_RECOVERY_TOKEN } from 'actions/Types';
import { updatePasswordStatuses } from '../constants/updatePasswordStatus';

export default (state = updatePasswordStatuses.unsubmitted, action) => {
  if (action.type === `${UPDATE_PASSWORD_FROM_RECOVERY_TOKEN}`) {
    return updatePasswordStatuses.submitted;
  }

  if (action.type === `${UPDATE_PASSWORD_FROM_RECOVERY_TOKEN}_SUCCESS`) {
    return updatePasswordStatuses.completed;
  }

  if (action.type === `${UPDATE_PASSWORD_FROM_RECOVERY_TOKEN}_FAILURE`) {
    return updatePasswordStatuses.error;
  }

  return state;
};
